import './bannerListStyle.sass';

import React from 'react';

class bannerView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentWillMount() {}

  componentWillReceiveProps(nextProps) {}

  render() {
    const { backgroundColor, fontSize, description } = this.props;
    return (
      <div className="viewContainer">
        <div className="bannerDetail" style={{ backgroundColor }}>
          <p className="bannerText" style={{ fontSize }}>
            {description}
          </p>
        </div>
      </div>
    );
  }
}

export default bannerView;
